import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-risk-analysis-grid',
  templateUrl: './customer-risk-analysis-grid.component.html',
  styleUrls: ['./customer-risk-analysis-grid.component.css']
})
export class CustomerRiskAnalysisGridComponent implements OnInit {
title="Risk Analysis List"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/customer-risk-analysis-grid/customer-risk-analysis-grid.component.ts